import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { orderApi } from '../../services/order';

interface OrderState {
  selectedOrder: any | null;
  filters: {
    status: string | null;
    sortBy: string | null;
    sortOrder: 'asc' | 'desc';
  };
  pagination: {
    page: number;
    limit: number;
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: OrderState = {
  selectedOrder: null,
  filters: {
    status: null,
    sortBy: null,
    sortOrder: 'desc',
  },
  pagination: {
    page: 1,
    limit: 10,
  },
  isLoading: false,
  error: null,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setSelectedOrder: (state, action: PayloadAction<any | null>) => {
      state.selectedOrder = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<OrderState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.page = 1; // Скидаємо на першу сторінку при зміні фільтрів
    },
    setPagination: (state, action: PayloadAction<Partial<OrderState['pagination']>>) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearOrder: (state) => {
      state.selectedOrder = null;
      state.error = null;
    },
    resetFilters: (state) => {
      state.filters = {
        status: null,
        sortBy: null,
        sortOrder: 'desc',
      };
      state.pagination.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        orderApi.endpoints.getOrders.matchPending,
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        orderApi.endpoints.getOrders.matchFulfilled,
        (state) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        orderApi.endpoints.getOrders.matchRejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.error.message || 'Помилка завантаження замовлень';
        }
      );
  },
});

export const {
  setSelectedOrder,
  setFilters,
  setPagination,
  setLoading,
  setError,
  clearOrder,
  resetFilters,
} = orderSlice.actions;

export default orderSlice.reducer; 